import {Event, Channel} from "@unibuddy/sockets";

const assistantConversationChannel = new Channel("assistant-conversation", {private: false});

export const assistantWritingEvent = new Event("assistant-writing", assistantConversationChannel);
export const assistantWritingEndEvent = new Event(
    "assistant-writing-end",
    assistantConversationChannel,
);
